import { useLocation, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/sidebar";
import { Trip } from "../../utils/types";
import { dateFormat, dateFormatWithTime, getQueryString, getStoredUserData, getUserSession, isAdmin, isAuthenticated, timeTraveled } from "../../utils/utils";
import Image from "../../components/image";
import { CareTripImage } from "../../components/image-assets";
import { MdClose } from "react-icons/md";
import { ApiClient } from "../../utils/apiclient";
import { ChangeEvent, useEffect, useState } from "react";
import { getCityNames } from "postcodes-tz";
import Spinner from "../../components/spinner";
import TopStrip from "../../components/top_strip";
import { Formik } from "formik";
import * as yup from 'yup'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const TripView = (props: any) => {
    const userData = getStoredUserData();
    const session = getUserSession()
    const client = new ApiClient(session?.accessToken);
    const navigate = useNavigate()
    const location = useLocation();
    const state = location.state;
    const params = useParams()
    const tripId = Number(params.tripId)
    const selectedTrip: Trip = state && state.trip ? state.trip : props.trip;
    const target = `${window.location.pathname}${getQueryString(window.location.href)}`
    const [trip, setTrip] = useState<Trip>(selectedTrip)
    const [endMileage, setEndMileage] = useState<number | undefined>(trip?.end_mileage)
    const [startTime, setStartTime] = useState<number>(Number(trip?.start_time))
    const [endTime, setEndTime] = useState<number>(Number(trip?.end_time))
    const [startLocation, setStartLocation] = useState<string>(trip?.start_location)
    const [startCity, setStartCity] = useState<string>(trip?.start_city)
    const [destination, setDestination] = useState<string>(trip?.destination)
    const [destinationCity, setDestinationCity] = useState<string>(trip?.destination_city)
    const [remark, setRemark] = useState<string | undefined>(trip?.remark ? trip?.remark : "")
    const [isLoading, setIsLoading] = useState<boolean>(false)


    const showNotifications = () => {
        navigate(`/notifications/${userData?.id}`)
    }
    const getTripDetails = async (tripId: number) => {
        const res = await client.getTripDetail(tripId)
        if (res.status == 401) {
            alert('Your session expired. Please signin again');
            navigate('/login', { state: { targetPath: `/trips/view/${tripId}` } })
        }
        else updateDetails(res.data)
    }
    const updateDetails = (trip: Trip) => {
        setTrip(trip);
        setEndMileage(trip.end_mileage)
        setStartTime(Number(trip.start_time))
        setEndTime(Number(trip.end_time))
        setStartLocation(trip.start_location)
        setStartCity(trip.start_city)
        setDestination(trip.destination)
        setDestinationCity(trip.destination_city)
        setRemark(trip.remark)
    }
    const handleRemarkChange = (e: ChangeEvent<HTMLInputElement>) => {
        setRemark(e.currentTarget.value.trim())
    }
    const completeTrip = async () => {
        setIsLoading(true)
        let data: Partial<Trip> = {
            id: trip.id,
            request_id: trip.request_id,
            requestor: trip.requestor,
            driver: trip.driver,
            vehicle: trip.vehicle,
            vehicle_id: trip.vehicle_id,
            start_location: startLocation,
            destination: destination,
            end_mileage: endMileage,
            start_time: startTime,
            end_time: endTime,
            remark: remark,
            start_city: startCity,
            destination_city: destinationCity,
            closer: userData?.id

        };
        const request = await client.completeTrip(data)
        setIsLoading(false);
        navigate(-1)

    }
    const handleMileageChange = (e: ChangeEvent<HTMLInputElement>) => {
        const mileage = Number(e.currentTarget.value)
        if (mileage < trip.start_mileage) {
            e.currentTarget.classList.add('border')
            e.currentTarget.classList.add('border-red-500')
            setEndMileage(undefined)
        }
        else setEndMileage(mileage)
    }
    const handleEndTimeChange = (date: Date) => {
        setEndTime(date.getTime()/1000)
    }
    const handleStartTimeChange = (date: Date | null) => {
        if (date) setStartTime(date.getTime()/1000)

    }
    const handleDestinationChange = (e: ChangeEvent<HTMLInputElement>) => {
        setDestination(e.currentTarget.value)
    }
    const handleDestinationCityChange = (e: ChangeEvent<HTMLSelectElement>) => { setDestinationCity(e.currentTarget.value) }
    const handleStartLocationChange = (e: ChangeEvent<HTMLInputElement>) => { setStartLocation(e.currentTarget.value) }
    const handleStartCityChange = (e: ChangeEvent<HTMLSelectElement>) => {
        setStartCity(e.currentTarget.value)
    }
    const formHandler = (formValues: any) => {

    }
    const validationSchema = yup.object({
        end_mileage: yup.number().required("Please fill in end mileage").min(trip?.start_mileage + 1, "End mileage cannot be lower than start mileage"),
        start_time: yup.string().required("Please fill in start time"),
        end_time: yup.string().required("Please fill in end time"),
        start_location: yup.string().required("Please fill in start location"),
        start_city: yup.string().required("Please select start city"),
        destination: yup.string().required("Please fill in destination"),
        destination_city: yup.string().required("Please select destination city"),

    })

    useEffect(() => {
        if (isAuthenticated()) {
            if (tripId || trip == null) getTripDetails(tripId);
        }
        else navigate('/login', { state: { targetPath: target } })
    }, [])
    return (
      <>
        <div className='w-full flex justify-end items-center bg-gray-100 pe-4'>
          <TopStrip user={userData} />
        </div>
        <main className='w-full flex bg-white min-h-full'>
          <div className='md:w-2/12 flex flex-col items-start text-center justify-center'>
            <Sidebar
              notificationCount={[].length}
              user={userData}
              active={4}
            />{' '}
            f
          </div>

          <div className='md:w-9/12 mx-auto space-y-4 mt-2'>
            <div className='w-full'>
              <div className='w-full flex items-center justify-between p2-4'>
                <p className='text-2xl font-bold'>Trip Details</p>
              </div>
              {trip && (
                <>
                  <div className='w-full flex justify-between items-start py-6 mx-auto border mt-6 h-full'>
                    <div className='p-4 w-full md:w-6/12'>
                      <Image
                        src={CareTripImage}
                        height={200}
                      />
                      <div className='w-full flex justify-center items-center space-x-5 mt-5 py-4'>
                        <p
                          className={`text-2xl ${
                            trip.status == 'Incomplete'
                              ? 'text-red-600'
                              : 'text-green-700'
                          }`}>{`${trip.status}`}</p>
                      </div>
                    </div>
                    <div className='ms-5 md:w-6/12'>
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Date: </label>
                        <p className='text-1xl'>
                          {dateFormat(trip.date_created)}
                        </p>
                      </div>
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Project: </label>
                        <p className='text-1xl'>{trip.request?.project}</p>
                      </div>
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Driver: </label>
                        <p className='text-1xl'>{`${trip.driver_detail?.fname} ${trip.driver_detail?.lname}`}</p>
                      </div>
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>
                          Start Location:{' '}
                        </label>
                        <p className='text-1xl'>{`${trip.start_location}, ${trip.start_city}`}</p>
                      </div>

                      {trip.start_time ? (
                        <div className='text-start mb-4'>
                          <label className='text-gray-500'>Start Time: </label>
                          <p className='text-1xl'>
                            {dateFormatWithTime(
                              trip.start_time as number,
                              true
                            )}
                          </p>
                        </div>
                      ) : null}
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Start Mileage: </label>
                        <p className='text-1xl'>{`${trip.start_mileage}`}</p>
                      </div>

                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Distance (Km): </label>
                        <p className='text-1xl'>
                          {endMileage ? endMileage - trip.start_mileage : 'N/A'}
                        </p>
                      </div>
                    </div>
                    <div className='ms-5 md:w-6/12'>
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Requestor: </label>
                        <p className='text-1xl'>{`${trip.request?.requestor_detail?.fname} ${trip.request?.requestor_detail?.lname}`}</p>
                      </div>
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Fund Code </label>
                        <p className='text-1xl'>{trip.request?.fundcode}</p>
                      </div>
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Vehicle: </label>
                        <p className='text-1xl'>{`${trip.vehicle_detail?.pnumber}`}</p>
                      </div>
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Route: </label>
                        <p className='text-1xl'>{`${trip.destination}, ${trip.destination_city}`}</p>
                      </div>

                      {trip.end_time ? (
                        <div className='text-start mb-4'>
                          <label className='text-gray-500'>End time: </label>
                          <p className='text-1xl'>
                            {dateFormatWithTime(trip.end_time as number, true)}
                          </p>
                        </div>
                      ) : null}
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>
                          End Mileage (Km):{' '}
                        </label>
                        <p className='text-1xl'>{`${endMileage}`}</p>
                      </div>
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>
                          Duration (Hours):{' '}
                        </label>
                        <p className='text-1xl'>
                          {startTime && endTime
                            ? timeTraveled(startTime, endTime)
                            : 'N/A'}
                        </p>
                      </div>
                    </div>
                    <div className='m-4 flex-col justify-between items-end h-full'>
                      <MdClose
                        className='text-2xl cursor-pointer hover:text-primary'
                        onClick={() => {
                          navigate(-1);
                        }}
                      />
                    </div>
                  </div>
                  <div className='w-full flex-column items-start justify-center mt-5 p-4 border mx-auto'>
                    {(trip.driver == userData?.id || isAdmin(userData)) &&
                    trip.status == 'Incomplete' ? (
                      <>
                        <Formik
                          validationSchema={validationSchema}
                          initialValues={{
                            remark: '',
                            end_mileage: trip.end_mileage,
                            start_time: trip.start_time,
                            end_time: trip.end_time,
                            start_location: trip.start_location,
                            start_city: trip.start_city,
                            destination: trip.destination,
                            destination_city: trip.destination_city,
                          }}
                          onSubmit={formHandler}>
                          {({handleSubmit, handleChange, touched, errors}) => (
                            <form
                              action='post'
                              onSubmit={handleSubmit}>
                              <div className='flex justify-between items-start space-x-5 mt-5 py-1'>
                                <div className='text-start mb-4'>
                                  <label className='text-gray-500'>
                                    Remark:{' '}
                                  </label>
                                  <input
                                    type='text'
                                    name='remark'
                                    className='form-control'
                                    placeholder='write your comment or remarks'
                                    onChange={(e) => {
                                      handleChange(e);
                                      handleRemarkChange(e);
                                    }}
                                  />
                                  {errors.remark && touched ? (
                                    <small className='text-red-500'>
                                      {errors.remark}
                                    </small>
                                  ) : null}
                                </div>
                                <div className='text-start mb-4'>
                                  <label className='text-gray-500'>
                                    End Mileage:{' '}
                                  </label>
                                  <input
                                    type='number'
                                    className='form-control'
                                    placeholder='Enter end mileage'
                                    name='end_mileage'
                                    id='end_mileage'
                                    onChange={(e) => {
                                      handleChange(e);
                                      handleMileageChange(e);
                                    }}
                                    min={trip.start_mileage}
                                  />
                                  {errors.end_mileage && touched ? (
                                    <small className='text-red-500'>
                                      {errors.end_mileage}
                                    </small>
                                  ) : null}
                                </div>

                                <div className='text-start mb-4'>
                                  <label className='text-gray-500'>
                                    Start Date and Time:{' '}
                                  </label>
                                  <br />
                                  <DatePicker
                                    selected={
                                      startTime
                                        ? new Date(startTime * 1000)
                                        : null
                                    }
                                    onChange={(date) => {
                                      if (date) {
                                        // Update Formik field value
                                        handleChange({
                                          target: {
                                            name: 'start_time',
                                            value: date.getTime(),
                                          },
                                        } as any);

                                        handleStartTimeChange(date);
                                      }
                                    }}
                                    showTimeSelect
                                    timeFormat='HH:mm'
                                    timeIntervals={15}
                                    dateFormat='dd/MM/yyyy HH:mm'
                                    className='form-control'
                                    placeholderText='Select start date and time'
                                  />
                                  <br />
                                  {errors.start_time && touched ? (
                                    <small className='text-red-500'>
                                      {errors.start_time}
                                    </small>
                                  ) : null}
                                </div>
                                <div className='text-start mb-4'>
                                  <label className='text-gray-500'>
                                    End Date and Time:{' '}
                                  </label>
                                  <br />
                                  <DatePicker
                                    selected={
                                      endTime ? new Date(endTime * 1000) : null
                                    }
                                    onChange={(date) => {
                                      if (date) {
                                        // Update Formik field value
                                        handleChange({
                                          target: {
                                            name: 'end_time',
                                            value: date.getTime(),
                                          },
                                        } as any);

                                        handleEndTimeChange(date);
                                      }
                                    }}
                                    showTimeSelect
                                    timeFormat='HH:mm'
                                    timeIntervals={15}
                                    dateFormat='dd/MM/yyyy HH:mm'
                                    className='form-control'
                                    placeholderText='Select end date and time'
                                  />
                                  <br />
                                  {errors.end_time && touched ? (
                                    <small className='text-red-500'>
                                      {errors.end_time}
                                    </small>
                                  ) : null}
                                </div>
                              </div>
                              <div className='flex justify-between items-center space-x-5 mt-2 py-1'>
                                <div className='text-start mb-4'>
                                  <label className='text-gray-500'>
                                    Start Location:{' '}
                                  </label>
                                  <input
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter start location'
                                    name='start_location'
                                    id='start_location'
                                    defaultValue={trip.start_location}
                                    onChange={(e) => {
                                      handleChange(e);
                                      handleStartLocationChange(e);
                                    }}
                                  />
                                  {errors.start_location && touched ? (
                                    <small className='text-red-500'>
                                      {errors.start_location}
                                    </small>
                                  ) : null}
                                </div>
                                <div className='text-start mb-4'>
                                  <label className='text-gray-500'>
                                    Start city:{' '}
                                  </label>
                                  <select
                                    className='form-control'
                                    name='start_city'
                                    id='start_city'
                                    defaultValue={trip.start_city}
                                    onChange={(e) => {
                                      handleChange(e);
                                      handleStartCityChange(e);
                                    }}>
                                    {getCityNames('asc').map((city: string) => {
                                      return (
                                        <option
                                          key={city}
                                          value={city}>
                                          {city}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  {errors.start_city && touched ? (
                                    <small className='text-red-500'>
                                      {errors.start_city}
                                    </small>
                                  ) : null}
                                </div>
                                <div className='text-start mb-4'>
                                  <label className='text-gray-500'>
                                    Destination:{' '}
                                  </label>
                                  <input
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter destination'
                                    name='destination'
                                    id='destination'
                                    defaultValue={trip.destination}
                                    onChange={(e) => {
                                      handleChange(e);
                                      handleDestinationChange(e);
                                    }}
                                  />
                                  {errors.destination && touched ? (
                                    <small className='text-red-500'>
                                      {errors.destination}
                                    </small>
                                  ) : null}
                                </div>
                                <div className='text-start mb-4'>
                                  <label className='text-gray-500'>
                                    Destination city:{' '}
                                  </label>
                                  <select
                                    className='form-control'
                                    name='destination_city'
                                    id='destination_city'
                                    defaultValue={trip.destination_city}
                                    onChange={(e) => {
                                      handleChange(e);
                                      handleDestinationCityChange(e);
                                    }}>
                                    {getCityNames('asc').map((city: string) => {
                                      return (
                                        <option
                                          key={city}
                                          value={city}>
                                          {city}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  {errors.destination_city && touched ? (
                                    <small className='text-red-500'>
                                      {errors.destination_city}
                                    </small>
                                  ) : null}
                                </div>
                              </div>
                              {/* <div className="w-full flex-column items-start justify-center mt-5 p-4 border mx-auto"> */}
                              <div className='flex justify-end items-center space-x-5 mt-2 py-1'>
                                {isLoading ? (
                                  <Spinner className='spinner-sm mt-4 ' />
                                ) : (errors &&
                                    Object.keys(errors).length > 0) ||
                                  startTime === 0 ||
                                  endTime === 0 ||
                                  endMileage === trip.start_mileage ? null : (
                                  <button
                                    className='bg-green-700'
                                    onClick={completeTrip}>
                                    Complete
                                  </button>
                                )}
                              </div>
                            </form>
                          )}
                        </Formik>

                        {/* </div> */}
                      </>
                    ) : (
                      <div className='text-start mb-4'>
                        <label className='text-gray-500'>Remarks </label>
                        <p className='text-1xl'>{trip.remark}</p>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </main>
      </>
    );
}
export default TripView;
